import component from './component.js';

export default component;
